import Controller from '@ember/controller';
import { tracked } from '@glimmer/tracking';
import { inject as service } from '@ember/service';
import moment from 'moment-timezone';
import { reads } from 'macro-decorators';
import { action } from '@ember/object';

export default class VisitorsNewController extends Controller {
  @service metrics;
  @service router;

  queryParams = ['signedInAt'];

  @tracked signedInAt;
  @tracked changeset;

  @reads('changeset.flow.signInFieldPage.signInFields') signInFields;

  get hostSignInField() {
    return this.signInFields.findBy('identifier', 'host');
  }

  get locationIsConnectedToProperty() {
    return this.model.connectedTenants.length > 0;
  }

  @action
  modelDidSave(options = {}) {
    if (options.redirectToIndex) {
      this.transitionToRoute('/visitors/entries');
    } else {
      this.metrics.trackEvent('Dashboard Entries - Add Another');
      this.send('refreshRoute');
    }
  }

  @action
  dateChanged(date) {
    const signedInAt = moment(date).format('YYYY-MM-DDTHH:mm');
    // update query-param
    this.signedInAt = signedInAt;
  }

  @action
  modelDidPartialSave({ id: entry_id }, _error) {
    this.router.transitionTo('visitors.entry', entry_id);
  }
}
